export default {
  'staticqr.invalide.account': '无效账户',
  'staticqr.loading': '加载中...',
  'staticqr.amount': '付款金额',
  'staticqr.amount.placeholder': '输入金额',
  'staticqr.rate': '实时汇率',
  'staticqr.fee.wechat': '商户服务费',
  'staticqr.fee': '商户服务费',
  'staticqr.total': '共计',
  'staticqr.reference.placeholder': '订单信息(可选)',
  'staticqr.reference.placeholder.required': '订单信息（必填）',
  'staticqr.error.api': '后台服务出错',
  'staticqr.error.api.transaction': '下单出错',

  'staticqr.wechatpay': '微信支付',
  'staticqr.alipay': '支付宝',

  'staticqr.number': '请输入有效金额',
  'staticqr.minimum': '金额最小0.01',
  'staticqr.maxmum': '金额最大100万',

  'confirm.method': '支付方式',
  'confirm.created': '创建时间',
  'confirm.transaction.id': '交易ID',

  'confirm.successful': '支付成功',
  'confirm.tips': '亲，记得展示此页面或截图给商家哦',

  'confirm.unpaid': '订单未支付',
  'confirm.notfound': '订单未找到',

  'confirm.invalid': '无效订单',

  'staticqr.reftoolong': '备注太长',
  'error.back.merchant': '返回商户',
  'error.title': '错误',
  'staticqr.need_reference': '需要输入备注',
  'staticqr.reference.placeholder.code': '请在此处填写code',
  'staticqr.reference.placeholder.invoice': '请填写invoice number'
};



// WEBPACK FOOTER //
// ./src/i18n/locales/zh.js